import Button from "./AddButton";
import Panel from "./AddPanel";

export default {
    button: Button,
    panel: Panel,
    name: "add",
    panelClass: "add-panel",
};
